let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dzPn4")).then(() => parcelRequire('4J3bW'));